import AuthFlowFrame from "../../components/AuthFlowFrame";
import { AuthFlowButton } from "../../types";
import { isJobberUrl } from "../../helpers";
import { Content } from "@jobber/components/Content";
import { Text } from "@jobber/components/Text";

const MARKETPLACE_URL = "https://secure.getjobber.com/marketplace";

function Step3() {
    const pageName = sessionStorage.getItem("selected_page_name");

    // Return the user to wherever they launched from (passed through by Jobber),
    // but only if it's a trusted Jobber URL; otherwise fall back to the marketplace.
    const returnUrl = sessionStorage.getItem("jobber_return_url");
    const link = returnUrl && isJobberUrl(returnUrl) ? returnUrl : MARKETPLACE_URL;

    const button: AuthFlowButton = {
        link,
        text: "Return to Jobber",
        type: "secondary",
        disabled: false,
        loading: false,
    };

    return (
        <AuthFlowFrame
            pretitle={"You are all set"}
            title={"Your integration is ready to go!"}
            step={3}
            totalSteps={3}
            button={button}
        >
            <Content spacing={"base"}>
                <Text size={"large"}>
                    {pageName
                        ? <>Your Jobber account and Facebook Page (<strong>{pageName}</strong>) are now connected.</>
                        : "Your Jobber account and Facebook are now connected."
                    }
                </Text>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step3;
